"use client"

import useLocale from "~/hooks/useLocale"
import VariantsRow from "~/components/ui/ProductHeader/components/ProductDetails/components/VariantsRow"
import { ClientViewItem } from "~/providers/GTMTrackingProvider/ClientViewItem"
import { getProductTrackingDataWithCollections } from "~/providers/GTMTrackingProvider/utils/get-product-tracking-data-with-collections"
import { variantToTrackingData } from "~/providers/GTMTrackingProvider/utils/variant-to-tracking-data"
import type { VariantsRowWithVariantSwitchProps } from "~/app/[locale]/products/[slug]/(components)/VariantsRowWithVariantSwitch"
import { useVariantSwitch } from "~/app/[locale]/products/[slug]/(hooks)/useVariantSwitch"

function ClientVariantsRowWithVariantSwitch({
  className,
  variants,
  productType,
  stockAlertEnabled,
  sizeGuideDisabled,
  defaultVariant,
  trackingData,
  sizeGuide,
  isInAddToCartPopin,
  withTracking,
  label,
  product,
}: VariantsRowWithVariantSwitchProps) {
  const { activeVariant, onChange } = useVariantSwitch({ variants, defaultVariant })
  const locale = useLocale()
  const itemTrackingDataWithCollections = getProductTrackingDataWithCollections(trackingData, product, locale)
  const processedTrackingData = { ...itemTrackingDataWithCollections, ...variantToTrackingData(activeVariant) }

  return (
    <>
      <VariantsRow
        className={className}
        variants={variants}
        defaultVariant={defaultVariant}
        onChange={onChange}
        productType={productType}
        stockAlertEnabled={stockAlertEnabled}
        isInAddToCartPopin={isInAddToCartPopin}
        sizeGuideDisabled={sizeGuideDisabled}
        sizeGuide={sizeGuide}
        label={label}
      />
      {withTracking && <ClientViewItem payload={processedTrackingData} deps={[activeVariant?.sku]} />}
    </>
  )
}

export default ClientVariantsRowWithVariantSwitch
